import type { KgInsightCategory } from '@api';
import {
  POSTHOG_TRACKING_SOURCES,
  type PosthogTrackingSource,
} from '@terminal/services/tracking/posthog/constants';

export const isEarningsCategory = (
  category: KgInsightCategory
): category is 'earnings_preview' | 'earnings_recap' =>
  category === 'earnings_preview' || category === 'earnings_recap';

export const getCatalystTrackingKey = (opts: {
  insightId: string;
  category: KgInsightCategory;
  entityTag?: string;
  themeId?: string;
}): string | undefined =>
  opts.insightId
    ? `${opts.insightId}-${(opts.category === 'company_catalyst' ? opts.entityTag : opts.themeId) ?? ''}`
    : undefined;

export const getCatalystTrackingSource = (
  category: KgInsightCategory
): PosthogTrackingSource =>
  category === 'company_catalyst'
    ? POSTHOG_TRACKING_SOURCES.CATALYST_INSIGHT_DRAWER
    : POSTHOG_TRACKING_SOURCES.MARKET_CATALYST_DRAWER;

export const getCatalystEmailDrawerTracking = (opts: {
  category: KgInsightCategory;
  insightId: string;
  entityTag?: string;
  themeId?: string;
}) => {
  const companyMode = opts.category === 'company_catalyst';

  return {
    type: companyMode ? ('company' as const) : ('market' as const),
    insightId: opts.insightId,
    entities: companyMode && opts.entityTag ? [opts.entityTag] : undefined,
    themeIds: !companyMode && opts.themeId ? [opts.themeId] : undefined,
  };
};
